import { ComponentPropsWithoutRef, FC } from "react";

type VerticalStackIconProps = {} & ComponentPropsWithoutRef<"svg">;

const VerticalStackIcon: FC<VerticalStackIconProps> = ({ ...rest }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      className={`${rest.className}`}
    >
      <path
        d="M8.02941 8.5H9.23529C10.4536 8.5 11.4412 9.47938 11.4412 10.6875V15.0627V19M8.02941 8.5V7.1875C8.02941 5.97938 9.01702 5 10.2353 5H12.5588M8.02941 8.5C8.02941 8.5 6.92416 8.5 5.70588 8.5C4.48761 8.5 3.5 9.47938 3.5 10.6875V20.3125C3.5 21.5206 4.48761 22.5 5.70588 22.5H9.23529C10.4536 22.5 11.4412 21.5206 11.4412 20.3125V19M11.4412 19H13.7647C14.983 19 15.9706 18.0206 15.9706 16.8125V15.5M12.5588 5H13.7647C14.983 5 15.9706 5.97938 15.9706 7.1875V15.5M12.5588 5V3.6875C12.5588 2.47938 13.5464 1.5 14.7647 1.5H18.2941C19.5124 1.5 20.5 2.47938 20.5 3.6875V13.3125C20.5 14.5206 19.5124 15.5 18.2941 15.5H15.9706"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default VerticalStackIcon;
